import React, { useState } from 'react'

type FocusEvent = <T = HTMLInputElement>(e: React.FocusEvent<T>) => void

export const useFocus = <T = HTMLInputElement>(
  focus = false,
  onFocus?: FocusEvent,
  onBlur?: FocusEvent
) => {
  const [focused, setFocused] = useState(focus)

  const handleFocus = (e: React.FocusEvent<T>) => {
    onFocus?.(e)

    setFocused(true)
  }

  const handleBlur = (e: React.FocusEvent<T>) => {
    onBlur?.(e)

    setFocused(false)
  }

  return [focused, handleFocus, handleBlur] as [boolean, FocusEvent, FocusEvent]
}
